import React, { useEffect } from 'react';

const ToastNotification = ({ show, onClose, message, type = 'success' }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className="admin-crud-toast">
      <div className={`admin-crud-toast-content admin-crud-toast-${type}`}>
        <div className="admin-crud-toast-header">
          <strong>{type === 'success' ? 'Success' : 'Error'}</strong>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'white' }}>✕</button>
        </div>
        <div className="admin-crud-toast-body">{message}</div>
      </div>
    </div>
  );
};

export default ToastNotification;